export const navList = [
  {
    title: '刺激精细训练',
    subTitle: 'Ambyopia Training',
    content:
      '本类训练用于弱视增视阶段，训练时不需要佩戴红蓝眼镜。画面中特定背景和视标会刺激视神经细胞发育，促使差眼受到不同空间频率的刺激，达到增视的目的。',
    path: '/home/shopTrain',
    img: 'images/rs.png',
    bgColor: '#20ca72',
    bgImage: 'images/rs-bg.png',
    key: 'rs',
    trainArray: [
      { name: '刺激训练', type: 'ST' },
      { name: '精细训练', type: 'EX' },
      { name: '多人训练', type: 'DR' },
      // { name: '脱抑制训练', type: 'MFBF' },
    ],
  },
  {
    title: '脱抑制同时视训练',
    subTitle: 'Amblyopia and Strabismus',
    content:
      '本类训练用于脱抑制及双眼视训练，训练时需要佩戴红蓝眼镜。通过红蓝眼镜分视让每只眼看到不同的视标，逐渐去除优势眼对弱视眼的抑制，建立正常的双眼视野。',
    path: '/home/shopTrain',
    img: 'images/sgn.png',
    bgColor: '#ffca30',
    bgImage: 'images/rsxs-bg.png',
    key: 'rsxs',
    trainArray: [
      // { name: '精细训练', type: 'EX' },
      // { name: '刺激训练', type: 'ST' },
      { name: '脱抑制训练', type: 'MFBF' },
      { name: '同时视训练', type: 'SV' },
      // { name: '集合训练', type: 'FU' },
      // { name: '散开训练', type: 'DV' },
    ],
  },
  {
    title: '融合立体视训练',
    subTitle: 'Binocular Vision',
    content:
      '本类训练用于高阶视功能训练，训练时需要佩戴红蓝眼镜。利用多种运动方式诱导双眼产生融合，并且利用物象偏移形成立体感/深度感，达到扩大融合范围、建立立体感知能力的目的。',
    path: '/home/shopTrain',
    img: 'images/ksjc.png',
    bgColor: '#fb5fc4',
    bgImage: 'images/sgn-bg.png',
    key: 'sgn',
    trainArray: [
      // { name: '脱抑制训练', type: 'MFBF' },
      // { name: '同时视训练', type: 'SV' },
      { name: '集合训练', type: 'FU' },
      { name: '散开训练', type: 'DV' },
      { name: '立体视训练', type: 'STE' },
    ],
  },
  {
    title: '3D短片',
    subTitle: '3D video',
    content:
      '3D短片可供多人同时观看，请使用3D电视或3D投影仪中进行投屏。观看时请佩戴电视或投影仪对应的配套3D眼镜。',
    path: '/home/shopTrain',
    img: 'images/movie.png',
    bgColor: '#25aeff',
    bgImage: 'images/movie-bg.png',
    key: 'movie',
    trainArray: [],
  },
  {
    title: '在线检查',
    subTitle: 'Online Examination',
    content:
      '本检查为定性检查，包含抑制度和眼位检查。可快速筛查出患者双眼是否抑制以及眼位情况，为后续的训练效果评估提供参考依据。',
    path: '/home/examine',
    img: 'images/rsxs.png',
    bgColor: '#a25ddc',
    bgImage: 'images/ksjc-bg.png',
    key: 'ksjc',
    trainArray: [],
  },
]
export const trainType = [
  { name: '精细训练', type: 'EX' },
  { name: '刺激训练', type: 'ST' },
  { name: '脱抑制训练', type: 'MFBF' },
  { name: '同时视训练', type: 'SV' },
  { name: '集合训练', type: 'FU' },
  { name: '散开训练', type: 'DV' },
  { name: '立体视训练', type: 'STE' },
]
export const movies = [
  {
    title: '3D短片',
    data: [
      {
        src: 'https://files.babyeye.com/Asahiyama%20Zoo.mp4',
        cover:
          'https://files.babyeye.com/video/sdx/%E5%8A%A8%E7%89%A9%E4%B8%96%E7%95%8C.jpg',
        name: '走进动物园',
      },
    ],
  },
  {
    title: '龙之谷',
    data: [
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors01.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long01.jpg',
        name: 'part-01',
      },
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors02.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long02.jpg',
        name: 'part-02',
      },
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors03.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long03.jpg',
        name: 'part-03',
      },
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors04.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long04.jpg',
        name: 'part-04',
      },
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors05.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long05.jpg',
        name: 'part-05',
      },
    ],
  },
  {
    title: '逗鸟外传',
    data: [
      {
        src: 'https://files.babyeye.com/video/vr/storks01.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao01.jpg',
        name: 'part-01',
      },
      {
        src: 'https://files.babyeye.com/video/vr/storks02.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao02.jpg',
        name: 'part-02',
      },
      {
        src: 'https://files.babyeye.com/video/vr/storks03.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao03.jpg',
        name: 'part-03',
      },
      {
        src: 'https://files.babyeye.com/video/vr/storks04.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao04.jpg',
        name: 'part-04',
      },
      {
        src: 'https://files.babyeye.com/video/vr/storks05.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao05.jpg',
        name: 'part-05',
      },
    ],
  },
]
